<template>
</template>
<style></style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
  props: ['sendData'],
  data() {
    return {
    };
  },
  methods: {
    loadInit() {
      Swal.fire({
        title: `¿Estás seguro de eliminar el registro de ${this.sendData.nombre}?`,
        text: "¡Este cambio no se puede revertir!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteItem();
        } else {
          this.closeDelete();
        }
      })
    },
    closeDelete() {
      this.$emit("closeDelete");
    },
    deleteItem() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .delete(RUTA_API + "/medico/" + this.sendData.idMedico + "/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se eliminó correctamente!",
                icon: "success",
              });
              this.closeDelete();
            })
            .catch((res) => {
              Swal.fire({
                title: "¡Error!",
                text: "No se eliminó. Es posible que el mèdico este asignado a un paciente",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
              this.closeDelete();
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
  },
  mounted() { },
  computed: {
  },
  created() {
    this.loadInit();
  },
  components: {
  },
};
</script>